import fly from './fly'
import { getAuth } from '@/util/storage'
const auth = //'Cc9UYvXc7jBmN/-NP6iCcDtBzanpv2R8m26NFcyRP8VKxae4Exd1slpMaQzXxSLA'
getAuth()

// 我的积分
export const fetchIntegral = (min_id: string) =>
  fly
    .get(`/mall/v2/integral/getAll.json`, { min_id, auth })

// 签到详情
export const fetchCheckIn = () =>
  fly
    .get(`/mall/sign/list.json`, { auth })
    .then(res => res.data)